import { RouteLocationNormalized, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { $t } from "@/utils/locales";
import HTTP_CODE_STATUS from './httpCode'

export const isObject = (val: any) => val !== null && typeof val === 'object'
export function restructureMeta(to: RouteLocationNormalized) {
    const { meta } = to
    return meta
}
export function reLogin() {
    location.pathname !== '/login' && location.replace(`/login`)
}
export function isSuccess(res: any) {
    const SpecialCodes = [
        HTTP_CODE_STATUS.SUCCESS,
        HTTP_CODE_STATUS.JTS_UPLOAD_SUCCESS,
        HTTP_CODE_STATUS.TIME_BACK_STATUS,
        HTTP_CODE_STATUS.JTS_SUCCESS,
        HTTP_CODE_STATUS.JTS_SUCCESS_CONFIRM
    ]
    return res?.code && SpecialCodes.includes(res.code)
}

export function requestFail(data: any) {
    /** 弹窗只允许出现一个 */
    message.config({
        duration: 2, // 持续时间
        maxCount: 1, // 最大显示数, 超过限制时，最早的消息会被自动关闭
        top: '70px' // 到页面顶部距离
    })
    message.error(data?.msg ?? lang(data?.code) ?? lang('未知错误'))
    if (HTTP_CODE_STATUS.INVALID.includes(Number(data?.code)))
        setTimeout(() => {
            reLogin()
        }, 1000)
}
export function requestError(err: any) {
    console.log(err)
    const { response } = err
    let msg = lang('网络错误！请检查网络！')
    if (err.message.indexOf('timeout') !== -1) {
        msg = lang('请求超时')
    }

    if (response) {
        msg = response.status in serviceSttus ? serviceSttus[response.status] : lang('未知错误')
    }
    message.error(msg)
    if (HTTP_CODE_STATUS.INVALID.includes(Number(response?.status))) setTimeout(() => reLogin(), 1500)
}

export const hasPower = (key: string) => {
    // if (window.$wujie?.props?.btnPermissions) {
    //     return window.$wujie?.props?.btnPermissions(key)
    // }
    return true
}


export const lang = (txt:any) => {
    return $t(txt)
}


export const dataType = (data: any) => {
    return Object.prototype.toString.call(data).slice(8, -1).toLowerCase()
}

/**删除数组属性为空 */
export function deleteNullKey(obj: any) {
    Object.keys(obj).forEach((item) => {
        if (obj[item] === null) {
            delete obj[item]
        } else if (toString.call(obj[item]) === '[object Array]') {
            obj[item].forEach((i: object, k: number) => {
                obj[item][k] = deleteNullKey(i)
            })
        } else if (obj[item] !== null && typeof obj[item] === 'object') {
            obj[item] = deleteNullKey(obj[item])
        }
    })
    return obj
}
/**
 * 获取当前设备时区
 * @returns
 */
export function getTimezoneOffset() {
    const timezoneOffset = new Intl.DateTimeFormat().resolvedOptions().timeZone
    return timezoneOffset
}
/**排序的函数 */
export function objKeySort(data: object) {
    const obj = {}
    Object.keys(data)
        .sort()
        .forEach(function (item) {
            if (typeof data[item] !== 'object') {
                obj[item] = data[item]
            } else if (toString.call(data[item]) === '[object Array]') {
                obj[item] = []
                data[item].forEach((i: object, k: number) => {
                    if (typeof i === 'object') {
                        obj[item][k] = objKeySort(i)
                    } else {
                        obj[item][k] = i
                    }
                })
            } else if (data[item] !== null && typeof data[item] === 'object') {
                obj[item] = objKeySort(data[item])
            }
        })
    return obj
}
